import { render } from "./RegistrationRequestDialog.vue?vue&type=template&id=5b939b00&scoped=true"
import script from "./RegistrationRequestDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestDialog.vue?vue&type=script&lang=js"

import "./RegistrationRequestDialog.vue?vue&type=style&index=0&id=5b939b00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b939b00"]])

export default __exports__